<template>
<div>
  <div class="vrank flex flex-wrap items-center justify-center">
    <!-- <div class="sort-wrapper flex flex-wrap w-3/12 md:w-2/12 lg:hidden mb-3 text-center pr-2">
      <span class="flex-wrap w-full font-bold text-sm text-right pr-2">More Like Me</span>
      <ul class="w-1/5 flex flex-col text-center">
        <li v-for="(choice, index) in itemsarray" class="flex mb-2 h-12 justify-center items-center font-bold text-xl">
            {{ index + 1 }}
        </li>
      </ul>
      <draggable :list="itemsarray" animation="600" tag="ul" class="w-4/5 flex flex-col">
        <li :id="choice.column" v-for="(choice, index) in itemsarray" class="vrank-sort columnfill h-12 flex mb-2 overflow-hidden justify-center items-center rounded shadow w-full cursor-move text-sm">
              {{ choice.attributes['title'].text }}
        </li>
      </draggable>
      <span class="flex-wrap w-full font-bold text-sm text-right pr-2 -mt-2">Less Like Me</span>
        <div class="mt-3 inline-block m-auto" v-if="demo !== ('1')">
          <button id="submitResults" @click="putResults" type="submit" class="submitResults px-5 py-2">Next<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>
        <div class="mt-3 inline-block m-auto"  v-else>
          <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
        </div>
    </div> -->
    
    <div class="vrank-wrapper w-full md:w-3/5 lg:w-1/2 px-5 md:px-0">
      <h3 class="bg-gray-900 rounded-t-md mx-10 pt-2 pb-2 -mb-6">More Me</h3>
      <draggable :list="itemsarray" animation="600" tag="div" class="vrank-responsive" handle=".handle">
        <div :id="choice.column" v-for="(choice, index) in itemsarray" class="vrank-item">
          <div class="handle"></div>
          <!-- <div class="flex items-center absolute right-0 top-0 w-6 justify-center bg-gray-200 cursor-move">{{ index + 1 }}</div> -->
          <div class="flex-grow align-middle">
            <div class="attributes flex flex-col">
                    <h2 class="label relative">
                      {{ choice.attributes['title'].text }}
                    </h2>

                    <p class="description">
                      <img v-if="choice.attributes.image" :src="choice.attributes.image.text" :alt="choice.attributes.title.text" class="image float-right"/>
                      <span v-html="choice.attributes['description'].text">
                      {{ choice.attributes['description'].text }}</span>
                      <button
                        v-if="choice.attributes['showmore']"
                        class="showmore"
                        @click="showModal(index)"
                      > 
                        <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                      </button>
                      <card-modal :ref="'modal_' + index" v-if="choice.attributes['showmore']">
                        <span v-html="choice.attributes['showmore'].text"></span>
                      </card-modal>
                    </p>
            </div>
          </div>
        </div>
      </draggable>
      <h3 class="bg-gray-900 rounded-b-md mx-10 pt-1 pb-3 -mt-1">Less Me</h3>
      <div class="mt-3 inline-block m-auto" v-if="demo !== ('1')">
          <button id="submitResults" @click="putResults" type="submit" class="submitResults px-5 py-2">Next<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>
        <div class="mt-3 inline-block m-auto"  v-else>
          <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
        </div>
    </div>
    
  </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'

  export default {
    display: "Simple",
    order: 1,
      components: {
        draggable,
      },
        props: {
            array: '',
            route:'',
            demo:'',
        },
        data() {
          return {
            itemsarray: this.getItemsWithColumns(),
          }
        },
        methods: {
          showModal(index) {
            let modal_id = "modal_" + index;
            this.$refs[modal_id][0].show(index);
          },
          restartActivity() {
            $( ".submitResults").addClass( "loading" );
            location.reload();
          },
          getItemsWithColumns() {
            return this.array.map((item, index) => {
              item.column = 'column_' + (index + 1);
              return item;
            });
          },
            putResults: function (event) {
              $( "#submitResults").addClass( "loading" );
              axios.put(this.route, { 
                results: this.itemsarray.map(dataSet => dataSet.id)
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            }
              
          }
      
      };
</script>
